import { ConfigurationsContext } from '@squareup/sq-addons-web-sdk';

export function validateConfigurations(configurations: ConfigurationsContext) {
  const addonName = configurations.addon_localized_name_override || configurations.addonName;
  const locationId = configurations.locationId;
  const programId = configurations.programId;
  const trainingMode = convertToBoolean(configurations.trainingMode);

  let environmentUrl = configurations.environmentUrl as string;
  if (environmentUrl.endsWith('/')) {
    environmentUrl = environmentUrl.slice(0, -1);
  }

  return {
    addonName,
    environmentUrl,
    locationId,
    programId,
    trainingMode,
  };
}

export function convertToBoolean(value: string | boolean): boolean {
  return String(value).toLowerCase() === 'true';
}
